import { UPDATE_PROFILE } from 'root/src/client/logic/profile/actionIds'
import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { setProfile } = appStoreLenses

export default {
	[UPDATE_PROFILE]: (state, payload) => setProfile(payload, state),
}
